import axios, { AxiosRequestConfig } from "axios";
import { toast } from "react-toastify";
import { all_routes } from "../feature-module/router/all_routes";

// Define the response interface
export interface ApiResponse {
  success: boolean;
  message: string;
  data?: any;
}

const axiosInstance = axios.create({
  timeout: 40000,
});

// Move hooks outside the function
// const refreshAuthToken = async () => {
//     // try {
//     //     const response = await axios.post(webServiceUrl.GET_TOKEN, {
//     //         username: "mobile_app",
//     //         password: "password"
//     //     });

//     //     if (response?.data?.authtoken) {
//     //         localStorage.setItem("token", response.data.authtoken); // Store new token
//     //         return response.data.authtoken;
//     //     }
//     // } catch (error) {
//     //     console.error("Failed to refresh token:", error);
//     //     return null;
//     // }
// };

// ===================

// const AXIOSCONFIGMETHOD = async (
//   method: "get" | "post" | "put" | "delete",
//   url: string,
//   payload?: any,
//   headers?: any,
//   isRetry: boolean = false
// ): Promise<ApiResponse | undefined> => {
//   try {
//     let token = localStorage.getItem("token");

//     const config: AxiosRequestConfig = {
//       method,
//       url,
//       data: payload,
//       headers: {
//         ...headers,
//         Authorization: token ? `Bearer ${token}` : "",
//       },
//       responseType: headers?.responseType || "json", // Support blob
//     };

//     const resp = await axiosInstance(config);

//     // ✅ If responseType is blob, treat as file download
//     if (config.responseType === "blob") {
//       return {
//         success: true,
//         message: "File downloaded successfully",
//         data: [resp.data],
//       };
//     }

//     // ✅ Regular JSON response handling
//     if (resp?.data?.success === true) {
//       const data = resp?.data?.data || resp?.data;
//       const result = Array.isArray(data) ? data : data ? [data] : [];

//       return {
//         success: true,
//         message: resp?.data?.message || "Request successful",
//         data: result,
//       };
//     } else {
//       return {
//         success: false,
//         message: resp?.data?.message || "Unknown error occurred",
//         data: resp?.data,
//       };
//     }
//   } catch (error: any) {
//     const errorMessage =
//       error?.response?.data?.message ??
//       error?.message ??
//       "An unexpected error occurred";

//     if (error.code === "ECONNABORTED") {
//       console.warn("Request timed out.");
//     } else {
//       console.error("No Internet Connection detected.", error?.response);
//     }

//     toast.error(errorMessage);

//     return {
//       success: false,
//       message: errorMessage,
//       data: error?.response?.data ? [error.response.data] : [],
//     };
//   }
// };


// esko open karna hai 

const AXIOSCONFIGMETHOD = async (
  method: "get" | "post" | "put" | "delete",
  url: string,
  payload?: any,
  headers?: any,
  isRetry: boolean = false
): Promise<ApiResponse | undefined> => {
  try {
    let token = localStorage.getItem("accessToken");

    const config: AxiosRequestConfig = {
      method,
      url,
      data: payload,
      headers: {
        ...headers,
        Authorization: token ? `Bearer ${token}` : "",
      },
      responseType: headers?.responseType || "json", // Handle blob
    };

    const resp = await axiosInstance(config);
    // console.log(resp, "mannu nbvbvn")

    if (config.responseType === "blob") {
      return {
        success: true,
        message: "File downloaded successfully",
        data: [resp.data],
        // @ts-ignore
        headers: resp.headers, // 👈 Add this if you want to read content-disposition
      } as any;
    }
// console.log(resp, "mannu vikash")

    if (resp?.data?.success === true) {
      const data = resp?.data?.data || resp?.data;
      // const result = Array.isArray(data) ? data : data ? [data] : [];

      return {
        success: true,
        message: resp?.data?.message || "Request successful",
        data,
      };
    } else {
      return {
        success: false,
        message: resp?.data?.message || "Unknown error occurred",
        data: resp?.data,
      };
    }
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ??
      error?.message ??
      "An unexpected error occurred";

    // toast.error(errorMessage);

  
    // window.location.href = all_routes?.error404;

    return {
      success: false,
      message: errorMessage,
      data: error?.response?.data ? [error.response.data] : [],
    };
  }
};



// ============================

// const AXIOSCONFIGMETHOD = async (
//   method: "get" | "post" | "put" | "delete",
//   url: string,
//   payload?: any,
//   headers?: any,
//   isRetry: boolean = false // To avoid infinite loops
// ): Promise<ApiResponse | undefined> => {
//   try {
//     let token = localStorage.getItem("token");

//     const respData = {
//       method,
//       url,
//       data: payload,
//       headers: {
//         ...headers,
//         Authorization: token ? `Bearer ${token}` : "",
//       },
//     };

//     const resp = await axiosInstance(respData);
//     // console.log(resp)

//     if (resp?.data?.success === true) {
//       const data = resp?.data?.data || resp?.data;
//       const result = Array.isArray(data) ? data : data ? [data] : [];

//       return {
//         success: true,
//         message: resp?.data?.message || "Request successful",
//         data: result,
//       };
//     } else {
//       return {
//         success: false,
//         message: resp?.data?.message || "Unknown error occurred",
//         data: resp?.data,
//       };
//     }
//   } catch (error: any) {
//     const errorMessage =
//       error?.response?.data?.message ??
//       error?.message ??
//       "An unexpected error occurred";

//     if (error.code === "ECONNABORTED") {
//       console.warn("Request timed out.");
//     } else {
//       console.error(
//         "No Internet Connection detected. try again!",
//         error?.response
//       );
//     }
//     toast.error(error?.response?.data?.message);
//   }
// };

export default AXIOSCONFIGMETHOD;

//  catch (error: any) {
//         const errorMessage = error?.response?.data?.message ?? error?.message ?? 'An unexpected error occurred';

//         if (error.code === 'ECONNABORTED') {
//             console.warn('Request timed out.');
//         } else {
//             console.log("No Internet Connection detected. try again!", error)
//             // console.error('AXIOS Error:', error);
//             // console.error('Error response:', error?.response || error.message)
//             // console.error('Error response:', errorMessage)
//             // toast.success(errorMessage)
//         }

//         // const err = {
//         //     success: false,
//         //     message: errorMessage,
//         //     data: error?.response?.data ? [error.response.data] : [],
//         // };

//         // throw err
//         // return {
//         //     success: false,
//         //     message: errorMessage,
//         //     data: error?.response?.data ? [error.response.data] : [],
//         // };
//     }
